export default __webpack_public_path__ + "locales/es/About.json?hash=86f82dc707584801346248863db9cdda";